import {gql} from '@apollo/client'

export const GET_EMAILS = gql`
  query loadEmails {
    loadEmails {
      emails {
        id
        snippet
        fromEmail
        subject
        date
      }
      nextPageToken
    }
  }
`
